import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

// Admin-only settings documents.

const loopsSettingsRef = () => doc(db, 'admin_settings', 'loops');
const scraperSettingsRef = () => doc(db, 'settings', 'scraper');

/** Loops template IDs: { defaultTransactionalId, inviteTransactionalId, updatedAt, updatedBy }, or {}. */
export async function getLoopsSettings() {
  const snap = await getDoc(loopsSettingsRef());
  return snap.exists() ? snap.data() : {};
}

export function saveLoopsSettings(data, updatedBy) {
  return setDoc(loopsSettingsRef(), { ...data, updatedAt: Timestamp.now(), updatedBy }, { merge: true });
}

/** Scraper settings ({ frequency }), or {}. */
export async function getScraperSettings() {
  const snap = await getDoc(scraperSettingsRef());
  return snap.exists() ? snap.data() : {};
}

export function saveScraperSettings(data) {
  return setDoc(scraperSettingsRef(), data, { merge: true });
}
